module.exports = __webpack_public_path__ + "img/max8.9cd1b8c2.jpg";